module.exports = __webpack_public_path__ + "img/电梯动画5.057018bc.png";